import DestinationGroups from "./DestinationGroups";

export default DestinationGroups;
